import { useState } from 'react';

import styles from './Media.module.css';

interface MediaProps {
  src: string | undefined;
  alt: string;
  /** Ширина к высоте, например `4 / 3`. Резервирует место и держит CLS около нуля. */
  ratio?: string | undefined;
  /** Первый экран грузится немедленно, остальное лениво. */
  priority?: boolean | undefined;
  sizes?: string | undefined;
  className?: string | undefined;
}

/**
 * Фотография с зарезервированным местом и honest-состоянием.
 * Если изображения нет или оно не загрузилось, показывается нейтральная заглушка,
 * а не «сломанная» картинка.
 */
export function Media({
  src,
  alt,
  ratio = '4 / 3',
  priority = false,
  sizes,
  className,
}: MediaProps) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <div
      className={[styles.media, className].filter(Boolean).join(' ')}
      style={{ aspectRatio: ratio }}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt}
          sizes={sizes}
          loading={priority ? 'eager' : 'lazy'}
          decoding={priority ? 'sync' : 'async'}
          fetchPriority={priority ? 'high' : 'auto'}
          onError={() => {
            setFailed(true);
          }}
        />
      ) : (
        <span className={styles.fallback} role="img" aria-label={alt} />
      )}
    </div>
  );
}
